import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/8d648405d951b3d8106c0d6247f50299.jpg"
          alt="Ensure Windows hero"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/30"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 pt-24">
        <div className="max-w-2xl">
          <span
            className="inline-block text-amber-400 text-xs font-bold tracking-widest uppercase mb-5 border border-amber-400/50 px-4 py-1.5 rounded-full"
            style={{ fontFamily: "'Raleway', sans-serif" }}
          >
            Caterham, Surrey &amp; South London
          </span>
          <h1
            className="text-5xl lg:text-6xl xl:text-7xl font-bold text-white leading-tight mb-6"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Premium Windows &amp; Doors for Your Home
          </h1>
          <p
            className="text-lg text-stone-200 leading-relaxed mb-10 max-w-xl"
            style={{ fontFamily: "'Raleway', sans-serif" }}
          >
            Specialists in aluminium bifold doors, uPVC windows, composite doors, and conservatories. Trusted by homeowners across Surrey and South London for over 12 years.
          </p>
          <div className="flex flex-wrap gap-4">
            <Link
              to="/contact"
              className="bg-amber-600 hover:bg-amber-500 text-white font-semibold px-8 py-4 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer text-base"
              style={{ fontFamily: "'Raleway', sans-serif" }}
            >
              Get a Free Quote
            </Link>
            <Link
              to="/products"
              className="border border-white/60 hover:border-white text-white hover:bg-white/10 font-semibold px-8 py-4 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer text-base"
              style={{ fontFamily: "'Raleway', sans-serif" }}
            >
              View Products
            </Link>
          </div>

          {/* Trust Badges */}
          <div className="flex flex-wrap gap-6 mt-12">
            {[
              { icon: "ri-shield-check-line", text: "10 Year Guarantee" },
              { icon: "ri-star-fill", text: "4.9/5 Rating" },
              { icon: "ri-home-2-line", text: "500+ Homes" },
            ].map((badge) => (
              <div key={badge.text} className="flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className={`${badge.icon} text-amber-400`}></i>
                </div>
                <span className="text-white text-sm font-medium" style={{ fontFamily: "'Raleway', sans-serif" }}>
                  {badge.text}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 animate-bounce">
        <div className="w-5 h-5 flex items-center justify-center">
          <i className="ri-arrow-down-line text-white/60 text-xl"></i>
        </div>
      </div>
    </section>
  );
}
